module.exports = __webpack_public_path__ + "img/Hunter-dwarf-m-70.49cffc83.gif";